import BrowserHistory from './BrowserHistory';

export default BrowserHistory;
